module.exports = __webpack_public_path__ + "static/img/logo2.bb8f01e2.png";